<main>
  <!-- Hero Section -->
  <section
    class="bg-[url('/assets/images/Model3_54.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
  >
    <div
      class="container flex flex-col justify-center items-center text-center"
    >
      <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
        Visitor Agreement
      </h1>
      <p class="text-white font-semibold text-center text-lg lg:text-xl">
        Committed to Protecting Your Data with Transparency and Trust
      </p>
    </div>
  </section>

  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div class="container mx-auto lg:flex-row items-center w-full py-[1.6rem]">
      <div class="visitor-agreement-header p-2 rounded-md mb-6 border">
        <h2 class="text-xl lg:text-2xl font-bold p-3 border-b">
          VISITOR AGREEMENT FOR ONLY USED TESLA
        </h2>
        <p class="lg:text-lg p-3">
          <span class="font-bold">Effective Date:</span> May 11, 2025
        </p>
      </div>
      <div class="space-y-6">
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">Introduction</h2>
          <p>
            This Visitor Agreement (the “Agreement”) describes the terms and
            conditions that govern your casual browsing and informational use of
            the publicly available portions of the website located at
            <a
              class="font-bold underline text-[blue]"
              href="https://www.onlyusedtesla.com"
              >onlyUsedTesla.com</a
            >. (the “Site”). The Site is owned and operated by
            Qureshi MEDIA LLC, a New York limited liability company doing
            business as Only Used Tesla (“Only Used Tesla,” “we,” “our,” or
            “us”). By accessing or using the Site in any way—including merely
            scrolling through pages—you acknowledge that you have read,
            understood, and agree to be bound by this Agreement and our [Terms
            of Service] and [Privacy Statement] (collectively, the “Policies”).
            If you do not agree, exit the Site immediately.
          </p>
        </div>
        <div
          class="border-red-600/50 bg-red-50 text-gray-900 p-4 rounded-lg border flex gap-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-red-600 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <h5 class="text-gray-900 font-medium mb-1">Important Notice</h5>
            <p class="text-gray-700">
              This Agreement contains a binding arbitration clause and
              class‑action waiver (Section 10) that affect your rights.
            </p>
          </div>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Personal, Non‑Commercial Use Only
          </h2>
          <p>
            The Site, including vehicle listings, articles, data, images, and
            other content (“Content”), is provided solely for your personal,
            non‑commercial, informational use. You may print or download
            reasonable copies for personal reference, provided you (a) retain
            all proprietary notices, (b) do not modify the Content, and (c) do
            not use it for commercial purposes. Any automated scraping, data
            extraction, or bulk downloading is strictly prohibited without our
            prior written consent.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Ownership & Intellectual Property
          </h2>
          <p>
            All Content (other than user‑generated content) is owned by
            Only Used Tesla or its licensors and is protected by U.S. and
            international copyright, trademark, and other intellectual‑property
            laws. “ONLY USED TESLA” and associated logos are trademarks of
            Qureshi MEDIA LLC. Except as expressly permitted, you may not
            reproduce, distribute, publicly display, or create derivative works
            from the Site or Content.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Vehicle Listings & Third‑Party Content
          </h2>
          <ul class="list-disc pl-5">
            <li>
              <strong>No Offer or Advice. </strong>Vehicle listings are
              advertisements submitted by private sellers or licensed dealers.
              We are not a dealer or broker and do not represent that any
              listing constitutes a binding offer. You must communicate directly
              with the seller regarding price, condition, fees, taxes,
              financing, and title.
            </li>
            <li>
              <strong>Accuracy Disclaimer. </strong>While we encourage sellers
              to provide accurate information, we do not guarantee the
              correctness, completeness, or currency of any listing, feature,
              specification, pricing, or availability. You rely on all Content
              at your own risk.
            </li>
            <li>
              <strong>Third‑Party Sites. </strong>The Site may contain links to
              or integrations with third‑party sites (e.g., financing portals,
              VIN decoders). We do not control or endorse third‑party content
              and disclaim any responsibility for it.
            </li>
          </ul>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Permissible Linking to the Site
          </h2>
          <p>
            ou may include a plain‑text link to our home page for non‑commercial
            purposes, provided you do not (a) frame the Site, (b) create the
            impression of a partnership or endorsement, or (c) present
            misleading or defamatory content about Only Used Tesla. We may
            revoke permission to link at any time.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-1.5">
            Prohibited Conduct
          </h2>
          <strong class="mb-1.5 ms-2">You agree not to:</strong>
          <ul class="list-disc pl-8">
            <li>Violate any law or infringe any third‑party right;</li>
            <li>Use the Site to send unsolicited commercial messages;</li>
            <li>
              Interfere with Site security, functionality, or performance;
            </li>
            <li>
              Upload malware, attempt to reverse‑engineer, or bypass Site access
              controls;
            </li>
            <li>
              Collect information about other users without authorization;
            </li>
            <li>
              Engage in any activity that imposes an unreasonable load on our
              infrastructure;
            </li>
            <li>
              Use any robot, crawler, or other automated means to access the
              Site without express permission;
            </li>
            <li>
              Directly contact or solicit our advertisers, sellers, or other
              users for the purpose of promoting a competing advertising or
              listing service, or otherwise attempt to divert business away from
              Only Used Tesla. You acknowledge and agree that each such
              prohibited solicitation causes us substantial harm that is
              difficult to quantify; therefore, you agree to pay liquidated
              damages of US $5,000 per violation, which the parties agree is a
              reasonable pre‑estimate of actual damages and not a penalty.
            </li>
          </ul>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Disclaimer of Warranties. Disclaimer of Warranties
          </h2>
          <p>
            THE SITE AND CONTENT ARE PROVIDED “AS IS” AND “AS AVAILABLE.”
            ONLY USED TESLA DISCLAIMS ALL WARRANTIES (EXPRESS OR IMPLIED)
            INCLUDING, WITHOUT LIMITATION, ANY WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON‑INFRINGEMENT, AND
            ACCURACY OF INFORMATION. WE DO NOT WARRANT THAT THE SITE WILL BE
            UNINTERRUPTED, SECURE, OR ERROR‑FREE.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Limitation of Liability
          </h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, ONLY USED TESLA, ITS
            MEMBERS, EMPLOYEES, AND LICENSORS SHALL NOT BE LIABLE FOR ANY
            INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY
            DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OR INABILITY
            TO USE THE SITE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            OUR TOTAL LIABILITY SHALL NOT EXCEED US $100.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">Indemnity</h2>
          <p>
            You agree to indemnify and hold harmless Only Used Tesla and its
            affiliates from any claims, liabilities, damages, losses, and
            expenses (including reasonable attorneys’ fees) arising out of your
            breach of this Agreement or misuse of the Site.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Privacy & Monitoring
          </h2>
          <p>
            Your use of the Site is subject to our [Privacy Statement],
            including provisions regarding cookies, analytics, and
            session‑replay technologies. By accessing the Site, you consent to
            such monitoring and waive any claims under federal or state wiretap
            laws (including the California Invasion of Privacy Act).
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Dispute Resolution & Class‑Action Waiver
          </h2>
          <p>
            All disputes related to this Agreement or the Site will be handled
            according to the arbitration, venue, and class‑action waiver
            provisions outlined in Sections 15 and 16 of our [Terms of Service],
            which are incorporated by reference. YOU WAIVE ANY RIGHT TO
            PARTICIPATE IN A CLASS ACTION OR JURY TRIAL.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">Termination</h2>
          <p>
            We may suspend or terminate your access to the Site at any time,
            with or without notice, for any reason. Sections 2, 3, 6–10, and 12
            shall survive any termination.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">Governing Law</h2>
          <p>
            This Agreement is governed by the laws of the State of New York
            (without regard to its conflict‑of‑law principles) and the Federal
            Arbitration Act.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">
            Modifications to Agreement
          </h2>
          <p>
            We may modify this Agreement at any time by posting an updated
            version with a new “Effective Date.” Continued use of the Site after
            posting constitutes acceptance of the modifications.
          </p>
        </div>
        <div>
          <h2 class="text-2xl lg:text-2xl font-bold mb-3">Contact Us</h2>
          <div>
            <p>Qureshi MEDIA LLC</p>
            <p>PO Box 1890</p>
            <p>Bellport, NY 11713 USA</p>
            <p>
              Email:
              <a
                href="mailto:info@onlyusedtesla.com"
                class="text-blue-600 hover:underline"
                >info&#64;onlyusedtesla.com</a
              >
            </p>
          </div>
        </div>
        <p class="italic mt-12">
          This Visitor Agreement is provided for informational purposes only and
          does not constitute legal advice. Consult qualified counsel to ensure
          compliance with applicable laws.
        </p>
        <p>
          We've had competitors contact our customers to pitch them thier
          advertising platform and i want to say FINE them $5k for each attempt
          one time a customer who was advertising his tesla was contacted by a
          competitor to list with them and i found them and if they or anyone
          else does it again can i fine them $5k? for each violiation? if yes
          can you write a paragraph for it ? 
        </p>
      </div>
    </div>
  </section>
</main>
